import { render, staticRenderFns } from "./ManualOrderList.vue?vue&type=template&id=ed328682"
import script from "./ManualOrderList.vue?vue&type=script&lang=js"
export * from "./ManualOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports